import { Injectable } from '@angular/core';
import { EmailTemplate } from 'src/app/model/EmailTemplate.modals';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class EmailnotificationService {
  serverUrl: String = environment.serverUrl;
  constructor(private httpClient: HttpClient) { }
  getEmailTemplatesByApplication(appId: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    return this.httpClient.get(this.serverUrl + 'notification-manager/getEmailTemplatesByApplication/' + appId,httpOptions);
  }

  getEmailTemplate(templateId: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    return this.httpClient.get(this.serverUrl + 'notification-manager/getEmailTemplate/' + templateId,httpOptions);
  }

  deleteEmailTemplate(templateId: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
     return this.httpClient.delete(this.serverUrl + `notification-manager/deleteEmailTemplate/${templateId}`,httpOptions);
  }


  sendMail(templateId: any,params:any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    var data = { templateId:templateId,paramList:params};
    return this.httpClient.post(this.serverUrl + 'email-notification/sendMail',data,httpOptions);
  }


  saveEmailTemplate(modal: EmailTemplate) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    var result=this.httpClient.post(this.serverUrl + 'notification-manager/saveEmailTemplate', modal, httpOptions);
    return result;
  }


  updateTemplate(modal: EmailTemplate) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    var result=this.httpClient.put(this.serverUrl + 'notification-manager/updateEmailTemplate', modal, httpOptions);
    return result;
  }
  getEmailTemplateOptions(type:string, orgId:string){
    return this.httpClient.get(this.serverUrl + `notification-manager/getEmailTemplateOptions/${type}/${orgId}`);
  }
  getOrgEmailTemplates(orgId:string){
    return this.httpClient.get(this.serverUrl + `notification-manager/getOrganizationEmailTemplates/${orgId}`);

  }
}
